<template>
  <div class="br-add-document__card br-add-document__card--upload">
    <h2 class="br-add-document__upload-title">{{ $t('lbl_EMPBE_BR_UploadSection_Title') }}</h2>

    <div class="br-add-document__info-banner">
      <img
        :src="infoIcon"
        alt=""
        class="br-add-document__info-icon"
        width="20"
        height="20"
      />
      <div class="br-add-document__info-text">
        <p class="br-add-document__info-intro">{{ companyIntroText }}</p>
        <p v-if="chineseCompanyName" class="br-add-document__info-name">
          <strong>{{ chineseCompanyName }}</strong>
        </p>
        <p v-if="englishCompanyName" class="br-add-document__info-name">
          <strong>{{ englishCompanyName }}</strong>
        </p>
        <p v-if="!chineseCompanyName && !englishCompanyName" class="br-add-document__info-name">
          <strong>—</strong>
        </p>
      </div>
    </div>

    <div class="br-add-document__upload-body">
      <div class="br-add-document__upload-main">
        <ul class="br-add-document__tips">
          <li v-if="tip1"><span>{{ tip1 }}</span></li>
          <li v-if="tip2"><span>{{ tip2 }}</span></li>
          <li v-if="tip3"><span>{{ tip3 }}</span></li>
        </ul>

        <div class="br-add-document__dropzone-wrap">
          <div
            class="br-add-document__dropzone"
            :class="{
              'br-add-document__dropzone--dragover': isDragOver,
              'br-add-document__dropzone--error': scanAlertKeys.length > 0,
            }"
            @dragover.prevent="$emit('dragover')"
            @dragleave.prevent="$emit('dragleave')"
            @drop.prevent="$emit('drop', $event)"
            @click="$emit('pick-file')"
          >
            <input
              ref="fileInput"
              type="file"
              class="br-add-document__file-input"
              :accept="uploadAccept"
              @change="$emit('file-change', $event)"
            />
            <button
              type="button"
              class="br-add-document__upload-icon-btn"
              :aria-label="$t('lbl_EMPBE_BR_Upload_ClickHere')"
              @click.stop="$emit('pick-file')"
            >
              <feather type="upload" :size="40" class="br-add-document__upload-icon" />
            </button>
            <p class="br-add-document__dropzone-title">{{ $t('lbl_EMPBE_BR_Upload_DragTitle') }}</p>
            <p v-if="selectedFileName" class="br-add-document__selected-file">{{ selectedFileName }}</p>
          </div>
          <BrScanAlert :alert-keys="scanAlertKeys" />
        </div>
      </div>

      <div class="br-add-document__examples-header">
        <h3 class="br-add-document__examples-heading">{{ $t('lbl_EMPBE_BR_Examples_Heading') }}</h3>
        <p class="br-add-document__examples-intro">{{ $t('lbl_EMPBE_BR_Examples_Intro') }}</p>
      </div>
      <div class="br-add-document__examples-grid">
        <button
          v-for="(example, index) in exampleImages"
          :key="index"
          type="button"
          class="br-add-document__example-thumb"
          :aria-label="$t('lbl_EMPBE_BR_Example_Label')"
          @click="$emit('preview-example', example)"
        >
          <img :src="example.src" alt="" class="br-add-document__example-doc" />
          <span class="br-add-document__example-zoom" aria-hidden="true">
            <feather type="zoom-in" :size="24" />
          </span>
          <span class="br-add-document__example-label" aria-hidden="true">
            <span class="br-add-document__example-label-text">{{ $t('lbl_EMPBE_BR_Example_Label') }}</span>
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import BrScanAlert from './BrScanAlert.vue';
import { BR_UPLOAD_ACCEPT } from '../../../constants/brConfig';

export default {
  name: 'BrUploadSection',
  components: { BrScanAlert },
  props: {
    chineseCompanyName: { type: String, default: '' },
    englishCompanyName: { type: String, default: '' },
    infoIcon: { type: String, default: '' },
    exampleImages: { type: Array, default: () => [] },
    isDragOver: { type: Boolean, default: false },
    scanAlertKeys: { type: Array, default: () => [] },
    selectedFileName: { type: String, default: '' },
  },
  computed: {
    uploadAccept() {
      return BR_UPLOAD_ACCEPT;
    },
    tip1() {
      return String(this.$t('lbl_EMPBE_BR_Upload_Tip1') || '').trim();
    },
    tip2() {
      return String(this.$t('lbl_EMPBE_BR_Upload_Tip2') || '').trim();
    },
    tip3() {
      return String(this.$t('lbl_EMPBE_BR_Upload_Tip3') || '').trim();
    },
    /** 沿用系统 CompanyLine 文案前缀（你的公司：/ Your company:），中英文名分行展示 */
    companyIntroText() {
      const line = String(this.$t('lbl_EMPBE_BR_UploadSection_CompanyLine', {
        chineseCompanyName: '\u0001',
        englishCompanyName: '\u0002',
      }));
      return line
        .split('\u0001')[0]
        .replace(/\u0002/g, '')
        .trim();
    },
  },
  methods: {
    triggerFileInput() {
      this.$refs.fileInput?.click();
    },
  },
};
</script>
